import React, { useContext, useState } from 'react';
import { Form, Input, Button, Select, Modal, DatePicker, message, Spin } from 'antd';
import { BiPlusCircle } from "react-icons/bi";

import 'moment/locale/pt-br';
import locale from 'antd/es/date-picker/locale/pt_BR';

import api from '../../../api';
import { Context } from '../../../context/AuthContext';
import './add-sales-goal.css';

function AddSalesGoal(props) {
    const { userData } = useContext(Context);
    const [modalNewSalesGoal, setModalNewSalesGoal] = useState(false);
    const [addLoading, setAddLoading] = useState(false)

    const [value, setValue] = useState('');
    const [clientPayment, setClientPayment] = useState('');
    const [commissionPayment, setCommissionPayment] = useState('');
    const [month, setMonth] = useState('');

    const { TextArea } = Input;
    const { Option } = Select;

    function changeMonetaryField(val, setter) {
        let v = val;
        v = v.replace(/\D/g, "")
        v = v.replace(/(\d{1})(\d{14})$/, "$1.$2")
        v = v.replace(/(\d{1})(\d{11})$/, "$1.$2")
        v = v.replace(/(\d{1})(\d{8})$/, "$1.$2")
        v = v.replace(/(\d{1})(\d{5})$/, "$1.$2")
        v = v.replace(/(\d{1})(\d{1,2})$/, "$1,$2")
        setter("R$ " + v)
    }

    function formatMonetaryToNumber(val) {
        return val.replace("R$ ", '').replace(/\./g, '').replace(',', '.')
    }

    function onChangeMonth(date, dateString) {
        if (dateString) {
            // DatePicker month format is "MM/YYYY"
            setMonth(dateString)
        }
    }

    function onChangeClientPayment(date, dateString) {
        setClientPayment(dateString || '')
    }

    function onChangeCommissionPayment(date, dateString) {
        setCommissionPayment(dateString || '')
    }

    function handleCommissionPercent(e) {
        // Só permite números positivos
        const val = e.target.value.replace(/[^0-9.,]/g, '');
        return val;
    }

    const onFinish = values => {
        let salesGoal = {
            responsible: userData.roles.includes('admin') ? values.responsible : undefined,
            month: month,
            company: values.company,
            value: formatMonetaryToNumber(value),
            effectiveDate: values.effectiveDate,
            operator: values.operator,
            clientPayment: clientPayment || undefined,
            commissionPercent: values.commissionPercent,
            commissionPayment: commissionPayment || undefined,
            contractBonus: values.contractBonus,
            listing: values.listing,
            obs: values.obs
        }

        createSalesGoal(salesGoal);
    };

    async function createSalesGoal(salesGoal) {
        setAddLoading(true);
        await api.post('/sales-goals', salesGoal).then(async response => {
            const { data } = await api.get('/sales-goals');
            props.setSalesGoals(data.salesGoals)
            setModalNewSalesGoal(false)
            setAddLoading(false)
            // Reset fields
            setValue('')
            setClientPayment('')
            setCommissionPayment('')
            setMonth('')
            message.success('Nova meta de venda criada com sucesso!');
        }).catch(error => {
            console.log(error)
            setAddLoading(false)
            message.error('Erro ao criar nova meta de venda.');
        })
    }

    return (
        <div>
            <div className="add-buttons">
                <div className="add-customer" onClick={() => setModalNewSalesGoal(true)} style={{ width: '100%' }}>
                    <BiPlusCircle size="20px" />
                    <span>Criar nova meta de venda</span>
                </div>
            </div>

            <Modal
                visible={modalNewSalesGoal}
                title="Criar nova meta de venda"
                onCancel={() => setModalNewSalesGoal(false)}
                footer={false}
                centered
                width={800}
                maskClosable={false}
            >
                <div className="add-customer-step-1">
                    <Spin tip="Criando meta..." spinning={addLoading}>
                        <Form
                            labelCol={{ span: 6 }}
                            wrapperCol={{ span: 16 }}
                            layout="horizontal"
                            onFinish={onFinish}
                        >
                            <Form.Item label="Mês" rules={[{ required: true, message: 'Mês é obrigatório' }]}>
                                <DatePicker
                                    picker="month"
                                    format="MM/YYYY"
                                    placeholder="Selecione o mês"
                                    locale={locale}
                                    style={{ width: '50%' }}
                                    onChange={onChangeMonth}
                                />
                            </Form.Item>

                            <Form.Item label="Empresa" name="company" rules={[{ required: true, message: 'Empresa é obrigatório' }]}>
                                <Input />
                            </Form.Item>

                            <Form.Item label="Valor" rules={[{ required: true, message: 'Valor é obrigatório' }]}>
                                <Input value={value} onChange={(e) => changeMonetaryField(e.target.value, setValue)} style={{ width: '50%' }} />
                            </Form.Item>

                            <Form.Item label="Data Vigência" name="effectiveDate">
                                <Input placeholder="DD/MM/YYYY" />
                            </Form.Item>

                            <Form.Item label="Operadora" name="operator">
                                <Select placeholder="Selecione uma operadora" showSearch
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {props.wallets &&
                                        props.wallets.map((wallet) => (
                                            <Option key={wallet._id} value={wallet._id}>{wallet.name}</Option>
                                        ))
                                    }
                                </Select>
                            </Form.Item>

                            <Form.Item label="Pgto Cliente">
                                <DatePicker
                                    format="DD/MM/YYYY"
                                    placeholder="Selecione a data"
                                    locale={locale}
                                    style={{ width: '50%' }}
                                    onChange={onChangeClientPayment}
                                />
                            </Form.Item>

                            <Form.Item label="Comissão %" name="commissionPercent"
                                getValueFromEvent={handleCommissionPercent}
                                normalize={(value) => value.replace(/[^0-9.,]/g, '')}
                            >
                                <Input
                                    style={{ width: '30%' }}
                                    placeholder="%"
                                    type="text"
                                    inputMode="decimal"
                                />
                            </Form.Item>

                            <Form.Item label="Pgto Comissão">
                                <DatePicker
                                    format="DD/MM/YYYY"
                                    placeholder="Selecione a data"
                                    locale={locale}
                                    style={{ width: '50%' }}
                                    onChange={onChangeCommissionPayment}
                                />
                            </Form.Item>

                            <Form.Item label="Tempo de Contrato" name="contractBonus">
                                <Select placeholder="Selecione o tempo" style={{ width: '50%' }}>
                                    <Option value="12 meses">12 meses</Option>
                                    <Option value="24 meses">24 meses</Option>
                                </Select>
                            </Form.Item>

                            <Form.Item label="Listagem" name="listing">
                                <Input />
                            </Form.Item>

                            {userData.roles.includes('admin') &&
                                <Form.Item label="Vendedor" name="responsible">
                                    <Select placeholder="Selecione um vendedor" showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {props.users &&
                                            props.users.map((user) => (
                                                <Option key={user._id} value={user._id}>{user.name}</Option>
                                            ))
                                        }
                                    </Select>
                                </Form.Item>
                            }

                            <Form.Item label="Observações" name="obs">
                                <TextArea placeholder="Digite aqui alguma observação..." allowClear style={{ height: '100px' }} />
                            </Form.Item>

                            <div className="add-customer-form-footer">
                                <Button className="green" type="primary" htmlType="submit" loading={addLoading}>Criar meta de venda</Button>
                            </div>

                        </Form>
                    </Spin>
                </div>
            </Modal>
        </div>
    )
}

export default AddSalesGoal;
